// extracted by mini-css-extract-plugin
export default {"main":"Workout_main__NrHBO","workout":"Workout_workout__8PuGj"};